/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import Loader from "../../../component/loader";
import HeaderNoAuth from "../../../component/header/headerNoAuth";
import classes from "./apiPortal.module.css";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import classes2 from "../documentation/documentation.module.css";

class ApiPortal extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {}

  render() {
    return (
      <React.Fragment>
        <HeaderNoAuth />
        <main style={{ maxWidth: "initial" }}>
          <Grid container>
            <Grid
              item
              size={{
                xs: 2,
                md: 1,
              }}
            >
              <ul className={classes.leftNavigation}>
                <li>
                  <Link className={classes.selected} to="/api-portal">
                    {" "}
                    API Portal{" "}
                  </Link>
                </li>
                <li>
                  <Link to="/api-read-only"> API Reference </Link>
                </li>
                <li>
                  <Link to="/registration">Developer Registration </Link>
                </li>
                <li>
                  <Link to="/sdk"> API SDKs </Link>
                </li>
                <li>
                  <Link to="/api-ref"> Try Out API </Link>
                </li>
                {/*<li> <Link to='/internal-api'> Internal API </Link> </li>*/}
              </ul>
            </Grid>
            <Grid
              item
              size={{
                xs: 1,
                md: 1,
              }}
            ></Grid>
            <Grid
              item
              size={{
                xs: 9,
                md: 10,
              }}
            >
              <h1 className={classes2.heading}>
                Welcome to Cumulator API Portal
              </h1>

              <p className={classes2.normalText}>
                Cumulator is a business platform, designed ground up to manage
                this complexity of Composition, Orchestration, and Monetization
                of Multi-Vendor IoT Solutions.
              </p>

              <p className={classes2.normalText}>
                Cumulator API (Application Programming Interfaces) allows
                developers to communicate with Cumulator Platform and leverage
                its capabilities. The following sections describe the API Basics
                and its REST interface details.
              </p>

              <h2 className={classes2.subHeading}>Using the Portal</h2>
              <p className={classes2.normalText}>
                Before we dive into the details about APIs, let's discuss
                details about how to use this API Portal. The Cumulator API
                Portal has the following pages.
              </p>

              <p className={classes2.normalText}>
                <ul>
                  <li className={classes2.definationText}>
                    <b>API Portal</b> - This Page. It provides the overview of
                    Cumulator APIs (Application Programming Interfaces).
                  </li>
                  <br />
                  <li className={classes2.definationText}>
                    <b>API Reference</b> - Describes the APIs and operations in
                    the read only mode.{" "}
                    <a href="/api-read-only">Visit this page </a>to understand
                    the details of APIs.
                  </li>
                  <br />
                  <li className={classes2.definationText}>
                    <b>Developer Registration</b> - A developer must register
                    with the Cumulator Platform to use the APIs.{" "}
                    <a href="/registration">Visit this page </a> to submit a
                    registration request.
                  </li>
                  <br />
                  <li className={classes2.definationText}>
                    <b>API SDKs</b> - You can download various Client SDK
                    (Software Development Kit) for interaction with Cumulator
                    API . We support popular programming languages. You must be
                    registered with Cumulator to be able to access{" "}
                    <a href="/sdk">this page.</a>
                  </li>
                  <br />
                  <li className={classes2.definationText}>
                    <b>Try Out API</b> - Allows a registered developer to try
                    out APIs from a Sandbox Environment. You can execute the
                    APIs from the embedded <a href="/api-ref">API console.</a>
                  </li>
                  <br />
                </ul>
              </p>

              <p className={classes2.normalText}>
                Let's discuss the API Basics and Rest Interfaces.
              </p>

              {/*Cumulator API  allows developers to interact with various Cumulator  functions. The set of APIs are provided for the following capabilities:*/}

              <hr />
              <h2 className={classes2.subHeading}>API Basics</h2>

              <div>
                <p className={classes2.normalText}>
                  Cumulator APIs allows developers to interact with various
                  Cumulator functions. The set of APIs are provided for the
                  following capabilities:
                  <br /> <br />
                  <ul>
                    <li>
                      <b>Authentication and Authorization</b>
                      <ol type={"a"}>
                        <li>Authenticating an API User</li>
                        <li>Refreshing an Access Token</li>
                        <li>Revoking an Access Token</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <b>Catalog Management</b>
                      <ol type={"a"}>
                        <li>Get Catalogs</li>
                        <li>Get Product Offering Categories</li>
                        <li>Get Product Offerings</li>
                        <li>Get Product Offering Details</li>
                        <li>
                          Get Selectable Included Products (For a Product Type))
                        </li>
                        <li>Get All Included Products (For a Product Type)</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <b>Shopping Cart Management</b>
                      <ol type={"a"}>
                        <li>Create Shopping Cart</li>
                        <li>Get Shopping Cart</li>
                        <li>Update Shopping Cart</li>
                        <li>Delete Shopping Cart</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <b>Order Management</b>
                      <ol type={"a"}>
                        <li>Get Orders</li>
                        <li>Get Details of Order</li>
                        <li>Submit Order</li>
                        <li>Accept Terms and Conditions</li>
                        <li>Cancel Order</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <b>Service Management</b>
                      <ol type={"a"}>
                        <li>Activate Service</li>
                        <li>Get Device Id from Partner Device</li>
                        <li>Get Service Credential (by IOTPartner)</li>
                        <li>Get Service Credential (by Device/App)</li>
                        <li>Get Services</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <b> Subscription Management</b>
                      <ol type={"a"}>
                        <li>Get Subscriptions</li>
                        <li>Edit Subscription</li>
                        <li>Cancel Subscription</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <b> Contract Management</b>
                      <ol type={"a"}>
                        <li>List Contracts</li>
                        <li>Create Contract</li>
                        <li>Get Details of Contract</li>
                        <li>Update Contract</li>
                        <li>Create Contract Term</li>
                        <li>Update Contract Term</li>
                        <li>Get Document for Contract Term</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <b> Provider Management</b>
                      <ol type={"a"}>
                        <li>Get Service Provider</li>
                        <li>Update Service Provider</li>
                        <li>Get Solution Provider</li>
                        <li>Update Solution Provider</li>
                        <li>Get Sales Channel Provider</li>
                        <li>Update Sales Channel Provider</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <b> Customer Management</b>
                      <ol type={"a"}>
                        <li>Get Customers</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <b> External ERP Integration Data Information</b>
                      <ol type={"a"}>
                        <li>Billing - Get Billing information for an Order</li>
                        <li>
                          Settlement - Get Settlement information for Provider
                        </li>
                        <li>Warehouse - Get Delivery details for an Order</li>
                      </ol>
                    </li>
                  </ul>
                  <br />
                  For detailed description for these APIs, refer to API
                  documentation
                </p>
              </div>

              <div>
                <br />
                <hr />
                <h3 className={classes2.subHeading}>REST Interfaces</h3>
                <p className={classes2.normalText}>
                  Cumulator API is built on the latest standards and
                  technologies. It uses REST, (Representational State Transfer),
                  an architectural style designed for distributed hypermedia, or
                  an Application Programming Interface.
                  <br />
                  <br />
                </p>
                <p className={classes2.normalText}>
                  Each REST command is centered around a resource. The resources
                  are represented thru specific URLs. Each URL call is an API
                  request and the returned data is its response. Cumulator API
                  uses REST over HTTP, that allows standard HTTP
                  GET/PUT/POST/DELETE methods to perform CRUD (CREATE, READ,
                  UPDATE, DELETE) operations on the system resources or end
                  points. The following HTTP methods are supported by Cumulator
                  IoT API. Each of the API in section "API Reference" describe
                  end point with their supported method(s). The section "Try our
                  API" gives you an opportunity to be able to try the APIs out.
                  However, you must be registered with Cumulator platform to do
                  so,
                </p>

                <h4 className={classes2.definitionHeading}>1. HTTP GET</h4>
                <p className={classes2.definationText}>
                  HTTP GET requests are used to retrieve information about a
                  resource for informational purpose and not to modify any
                  resources and hence are safe methods. GET methods are
                  idempotent as multiple identical requests will yield same
                  result until another method changes the state of the resource
                  on the server. GET usually returns HTTP response code 200 (ok)
                  when a resource is found, 404 (not found) when a resource is
                  not found and 400 (bad request) if the request itself is not
                  correctly formatted.
                  <br />
                  <br />A GET request can be made to a collection or a single
                  resource. When making the call for a single resource, resource
                  identifier is part of the URL. Following are a few examples
                  for the get calls.
                </p>
                <ul className={classes2.normalText}>
                  <li>
                    <b>All product offerings: </b>
                    <code>
                      GET {"<BaseURI>"}/cumulator/api/v4.4/productOfferings
                    </code>
                  </li>
                  <li>
                    <b> Set of products (with search criteria): </b>
                    <code>
                      GET {"<BaseURI>"}
                      /cumulator/api/v4.4/productOfferings?productCategoryId=CONN_CAT
                    </code>
                  </li>
                  <li>
                    <b> Single product: </b>
                    <code>
                      GET {"<BaseURI>"}
                      /cumulator/api/v4.4/productOfferings/10030
                    </code>{" "}
                    (here 10030 is the product id for a specific product).
                  </li>
                </ul>

                <h4 className={classes2.definitionHeading}>2. HTTP POST</h4>
                <p className={classes2.definationText}>
                  HTTP POST requests are used to create new resources inside a
                  collection. For example, creating a product in the collection
                  of products. HTTP post usually has a post body that is passed
                  along with the request. HTTP response code 201 (created) is
                  passed back along with the resource id (at a minimum) when the
                  intended resource is created successfully. This method is not
                  idempotent and so sending two identical requests will end up
                  creating two resources in the collection.
                </p>
                <ul className={classes2.normalText}>
                  <li>
                    <b>Create a new Order: </b>
                    <code>POST {"<BaseURI>"}/cumulator/api/v4.4/oders</code> (a
                    post body describing resource properties is needed)
                  </li>
                </ul>

                <h4 className={classes2.definitionHeading}>3. HTTP PATCH</h4>
                <p className={classes2.definationText}>
                  HTTP PATCH requests are used for partially update a resource.
                  For this reason, a resource identifier is required and is
                  generally passed in the path after the collection name. HTTP
                  method PUT can also be used for update of a resource. However,
                  a PUT method can create a resource if the resource does not
                  exist. Hence, Cumulator API uses PATCH to update an existing
                  resource partially.
                </p>
                <ul className={classes2.normalText}>
                  <li>
                    <b> Update an existing contract:</b>
                    <code>
                      PATCH {"<BaseURI>"}
                      /cumulator/api/v4.4/providers/digifleet/contracts/ctrt1090
                    </code>{" "}
                    (a post body describing resource properties to be updated is
                    needed)
                  </li>
                </ul>

                <h4 className={classes2.definitionHeading}>4. HTTP DELETE</h4>
                <p className={classes2.definationText}>
                  HTTP DELETE requests are used to delete a resource from the
                  collection.
                </p>
                <ul className={classes2.normalText}>
                  <li>
                    <b>Delete a subscription:</b>
                    <code>
                      DELETE {"<BaseURI>"}
                      /cumulator/api/v4/subscriptions/aef78-bgef8-1efac-b6gea
                    </code>{" "}
                    (no post body is needed)
                  </li>
                </ul>
                <br />
                <hr />

                <h3 className={classes2.subHeading}>API Structure</h3>
                <p className={classes2.normalText}>
                  Each API capability (operation) is an endpoint. {"<BaseURI>"}{" "}
                  is a parameter provided by Cumulator IoT. Each API will have
                  the following structure.
                  <br />
                  <br />
                  <ul>
                    <code>
                      GET {"<BaseURI>"}/cumulator/api/{"{version}"}
                      /product-categories
                    </code>
                    , where
                    <br />
                    <br />
                    <b>GET : </b>The HTTP Verb.
                    <br />
                    <br />
                    <b>BaseURI : </b>Base URI – Provided by Cumulator IoT.
                    Depends on environments.
                    <br />
                    <br />
                    <b>/cumulator/api/ : </b>Base Path of the API. Always
                    constant.
                    <br />
                    <br />
                    <b>{"{version}"} : </b>Version of the API. More on this in
                    versioning section.
                    <br />
                    <br />
                    <b>product-categories : </b> The resource. In this example,
                    this API returns all product categories.
                  </ul>
                </p>
              </div>

              <div>
                <br />
                <hr />
                <h3 className={classes2.subHeading}>API Security</h3>

                <h4 className={classes2.definitionHeading}>
                  1. Authentication
                </h4>
                <p className={classes2.definationText}>
                  All Cumulator API operations require authentication. Cumulator
                  API has its own authentication mechanism to authenticate and
                  authorize an API caller (typically a developer/builder).
                </p>

                <h4 className={classes2.definitionHeading}>
                  2. API Caller/Developer using Cumulator API
                </h4>
                <p className={classes2.definationText}>
                  API user (developer) initiates a call to Cumulator API
                  providing its login credentials to acquire a cumulator
                  authentication token. The token includes token metadata, along
                  with other details, an expiry time and the token itself. The
                  API caller then presents the token in header x-access-token
                  for any subsequent functional API calls. Cumulator API
                  validates the token and allow the API execution on successful
                  validation. The API Caller must do another authentication if
                  the provided token is expired to acquire a new token providing
                  the login credentials again.
                  <br />
                  <br />
                  Another API called refresh token is available to get a new
                  token before the current token expires, which enables an API
                  caller to continue an API session without having to do
                  multiple logins. However, this is a guideline and not a
                  mandate as API Caller/developer is responsible for its own
                  user experience.
                  <br />
                  <br />
                  Another API called revoke token is available for API Caller to
                  disable a token before it expires (for any reason).
                </p>

                <h4 className={classes2.definitionHeading}>
                  3. IoT Device/App using Cumulator API{" "}
                </h4>
                <p className={classes2.definationText}>
                  IoT Devices are onboarded to the System as a result of
                  activation. At this time devices are registered with a device
                  profile. An IoT Device calls Cumulator IOT for only one
                  purpose; getting service credential (see API reference for
                  more info). At this time a device must call the API with the
                  same device profile against which the call is authenticated.
                </p>

                <h4 className={classes2.definitionHeading}>4. Authorization</h4>
                <p className={classes2.definationText}>
                  Cumulator API callers (Developer) have access only to their
                  own data(products, orders, services, and subscriptions).
                </p>
              </div>

              <div>
                <br />
                <hr />

                <h3 className={classes2.subHeading}>API Usage Instructions</h3>
                <h4 className={classes2.definitionHeading}>
                  Onboarding an API Caller/Developer
                </h4>
                <p className={classes2.definationText}>
                  A Cumulator API caller is a developer that uses Cumulator APIs
                  to interact with Cumulator Platform. Cumulator developer
                  onboarding process requires you to work with a Digitize Things
                  product manager to provide you necessary access and define
                  your IoT Packaged Solutions. <br />
                  <br />
                  Please visit the{" "}
                  <a href="/registration"> Registration page </a> to request
                  registration to the API portal. Once the registration is
                  complete, you should be able to use the Cumulator APIs in the
                  sandbox environment.
                </p>

                <p className={classes2.definationText}>
                  The following section describes some of the important APIs and
                  how to use them.
                </p>
                <p className={classes2.definationText}>
                  <ul>
                    <li>
                      In order to call an API, you must obtain an access token.
                      For details on how to obtain the access token, please
                      refer to the API
                      <div className={classes2.figureWrapper}>
                        <img src="./access_token.png" alt={"Not found"} />
                      </div>
                    </li>

                    <li>
                      An access token is short lived. After the access token
                      expires, you must call the API to get another access
                      token. If you like to have a longer session, you must call
                      "auth/refresh_token" before the access token is expired.
                      <div className={classes2.figureWrapper}>
                        <img src="./refresh_token.png" alt={"Not found"} />
                      </div>
                    </li>

                    <li>
                      A valid access token must be passed in header as
                      x-access-token for subsequent API calls.
                      <div className={classes2.figureWrapper}>
                        <img src="./x-access-token.png" alt={"Not found"} />
                      </div>
                    </li>
                    <li>
                      View your product offerings, by calling "GET
                      /productOfferings".
                      <div className={classes2.figureWrapper}>
                        <img
                          src="./view_product_offerings.png"
                          alt={"Not found"}
                        />
                      </div>
                    </li>

                    <li>
                      Once you decide which products to order, place an order by
                      calling "POST /orders".
                      <div className={classes2.figureWrapper}>
                        <img src="./post_order.png" alt={"Not found"} />
                      </div>
                    </li>

                    <li>
                      Post Orders API returns Order Id and the applicable terms
                      and conditions that require customer's acceptance. After
                      you get the T&C approved by the customer, call "POST
                      /orders/&#123;orderId&#125;/tncs".
                      <div className={classes2.figureWrapper}>
                        <img src="./tnc.png" alt={"Not found"} />
                      </div>
                    </li>

                    <li>
                      After T&C acceptance, the products are provisioned and the
                      order is ready for activation. To activate any services in
                      the order, call "POST /services".
                      <div className={classes2.figureWrapper}>
                        <img src="./activation.png" alt={"Not found"} />
                      </div>
                    </li>

                    <li>
                      On successful activation, the services are ready to be
                      used. Based on the products, the activation API will
                      provide the credentials of the services as needed. These
                      credentials are used to authenticate with the service
                      providers. If you are using 3rd Party services in your
                      application, your application directly communicates to the
                      3rd party service through their SDK for service
                      consumption. Please see the "API SDKs" section for details
                      on how to develop applications for individual service
                      providers.
                    </li>
                    <br />

                    <li>
                      There are more APIs available for other operations like
                      viewing all your orders, subscriptions, editing and
                      cancelling subscriptions etc. Please go through the
                      swagger documentations and try them out.
                    </li>
                  </ul>
                </p>
              </div>
            </Grid>
          </Grid>
          <Loader loading={this.state.loading} />
        </main>
      </React.Fragment>
    );
  }
}

export default ApiPortal;
